import { render } from "./ListItem.vue?vue&type=template&id=2da936fd&scoped=true"
import script from "./ListItem.vue?vue&type=script&lang=js"
export * from "./ListItem.vue?vue&type=script&lang=js"

import "./ListItem.vue?vue&type=style&index=0&id=2da936fd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2da936fd"

export default script